// interfaces
import { CBCCPaymentOnboardingRequest } from "@payment-client/interfaces/CBCC";
import { PlaceOrderParams } from "@payment-client/interfaces/OrderPublic";

export const getCBCCPaymentOnboardingParams = (
    data: PlaceOrderParams,
    swiggyApplicationNumber?: string,
): CBCCPaymentOnboardingRequest => {
    const amount = Number(data.transaction_amount) || 0;
    /* eslint-disable @typescript-eslint/naming-convention */
    return {
        amount,
        payment_information: {
            payment_method: data.payment_cod_method,
            amount,
            payment_method_meta: {
                upi_transaction_info: {
                    intent_app: data.upi_transaction_info?.intent_app || "",
                    intent_app_display_name: data.upi_transaction_info?.intent_app_display_name || "",
                },
            },
        },

        swiggy_application_number: swiggyApplicationNumber || "",
    };
};
